import { processSilentRenew } from 'redux-oidc'
if (process.env.NODE_ENV !== 'prod') {
  console.log('silent renew')
}
processSilentRenew()
